module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Documento de identidad")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.dni),
      expression: "consumidor.dni"
    }],
    staticClass: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.consumidor.dni)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "dni", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nombre")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.nombre),
      expression: "consumidor.nombre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.nombre)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "nombre", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Correo electrónico")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.email),
      expression: "consumidor.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.consumidor.email)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "email", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Domicilio")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.direccion),
      expression: "consumidor.direccion"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.direccion)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "direccion", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Teléfono")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.telefono),
      expression: "consumidor.telefono"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.telefono)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "telefono", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nombre del padre o madre (Si es menor de edad)")]), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumidor.nombrePadre),
      expression: "consumidor.nombrePadre"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.consumidor.nombrePadre)
    },
    on: {
      "blur": _vm.sendData,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.consumidor, "nombrePadre", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("2. Datos del consumidor")]), _c('p', [_c('span', [_vm._v("Por favor ingrese sus datos, son obligatorios para poder hacer la reclamación")])]), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e944a6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Box-2-ingresar-datos-consumidor.vue
// module id = 81
// module chunks = 0